import { Component } from "@angular/core";
import { ItemCellEditorComponent } from "./item-cell-editor.component";

@Component({
  selector: 'ngx-categoryadvisorsappliers-cell-editor',
  templateUrl: './item-cell-editor.component.html',
  styleUrls: ['./item-cell-editor.component.scss']
})
export class CategoryAdvisorsAppliersCellEditorComponent extends ItemCellEditorComponent {

  constructor(){
    super();
    this.listaOpciones = [
      {
        "identifier": "1",
        "name": "Sector de uso profesional"
      },
      {
        "identifier": "2",
        "name": "Sector de asesoramiento"
      }
    ];
    console.log(this.listaOpciones);
  }


}
